import React from 'react'
import { Admin } from 'react-admin'
import { QueryClientProvider } from 'react-query'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { enGB } from 'date-fns/locale'
import { createBrowserHistory } from 'history'
import authProvider from './react-admin/providers/authProvider'
import i18nProvider from './react-admin/providers/i18nProvider'
import Dashboard from './react-admin/components/Dashboard/Dashboard'
import metargusTheme from './utils/constants/metargusTheme'
import dataProviderIndex from './react-admin/providers'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import MyLayout from './react-admin/components/layout/MyLayout/MyLayout'
import LoginPage from './pages/Login/LoginPage'
import routesWithAuth from './utils/helpers/routesWithAuth'
import resourcesWithAuth from './utils/helpers/resourcesWithAuth'
// App.scss should be imported last in order to not be overwritten by default styles.
import './App.scss'
import MaintenancePage from './pages/MaintenancePage/MaintenancePage'
import ErrorNotificationHandler from './components/ErrorNotificationHandler'
import queryClient from './queryClient'

const App = () => {
  const customRoutes = routesWithAuth()
  const resources = resourcesWithAuth()
  const history = createBrowserHistory()

  const isInMaintenance = process.env.REACT_APP_IS_IN_MAINTENANCE === 'true'
  if (isInMaintenance) {
    return <MaintenancePage />
  }


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enGB}>
      <QueryClientProvider client={queryClient}>
        <ErrorNotificationHandler />
        <Admin
          history={history} // Used to remove "#" from url
          theme={metargusTheme}
          loginPage={LoginPage}
          authProvider={authProvider}
          dataProvider={dataProviderIndex}
          dashboard={Dashboard}
          customRoutes={customRoutes}
          i18nProvider={i18nProvider}
          layout={MyLayout}
        >
          {resources}
        </Admin>
      </QueryClientProvider>
    </MuiPickersUtilsProvider>
  )
}

export default App
